import React, { useCallback } from "react";
import { PageType, useSdkContext } from "~/components/contexts";
import { useGA4CommonParameters, useSendImpressionEvents } from "~/components/rosetta/hooks";
import { SubscriptionButton } from "~/components/rosetta/subscription-button/styles";
export const ReactivateButton = ({
  className
}) => {
  const {
    config,
    currentPageType,
    handleTrackGA,
    handleTrackGA4,
    handleTrackMixPanel
  } = useSdkContext();
  const {
    computeGA4CommonParameters
  } = useGA4CommonParameters();
  const {
    captureTrackImpressionEventTargetElement
  } = useSendImpressionEvents({
    ga4Event: null,
    gaEvent: useCallback(() => ({
      action: "Reactivate/Masthead/Impression",
      category: "Reactivate",
      label: window.location.href
    }), [])
  });
  return /*#__PURE__*/React.createElement(SubscriptionButton, {
    className: className,
    ref: captureTrackImpressionEventTargetElement,
    onClick: () => {
      handleTrackMixPanel({
        name: "Subscription Entry Point",
        property: {
          Location: `${currentPageType === PageType.Article ? "Article" : "Homepage"} Masthead`
        }
      });
      handleTrackGA({
        action: "Reactivate/Masthead/Reactivate",
        category: "Reactivate",
        label: window.location.href
      });
      handleTrackGA4({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...computeGA4CommonParameters(),
          call_to_action: "reactivation",
          trigger_point: "masthead reactivation button"
        },
        subcategory: "entry_point"
      });
      window.location.href = `${config.subscribe.host}/?product=winback`;
    },
    "data-qa": "reactivate-button"
  }, "Reactivate Access");
};
ReactivateButton.displayName = "ReactivateButton";